<template>
    <div>
        <v-card class="review_card ma-1">
            <v-container>
                <v-card-title>
                    <span class="caption-font white--text">Reviews</span>
                </v-card-title>
                <v-row cols="12" class="ml-1 mr-1">
                    <v-col xs="12" sm="6" md="4" lg="3" xl="3">
                        <v-card class="score-semitrans-25" elevation="8">
                            <v-container>
                                <h5>Villa for You</h5>
                                <v-card-text>
                                    <v-row cols="12">
                                        <div v-if="this.hasData(this.reviews)">
                                            <table dense class="table_markup">
                                                <tr class="td_column_stat2">
                                                    <td>
                                                        <v-rating readonly :value="rating[4]" :length="length"
                                                            :size=this.starsize :color=this.starcolor
                                                            :background-color=this.starstrokecolor dense></v-rating>
                                                    </td>
                                                    <td class="td_markup td_column_stat100">
                                                        {{this.reviews.VFY.Score5}}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <v-rating readonly :value="rating[3]" :length="length"
                                                            :size=this.starsize :color=this.starcolor
                                                            :background-color=this.starstrokecolor dense></v-rating>
                                                    </td>
                                                    <td class="td_markup">{{this.reviews.VFY.Score4}}</td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <v-rating readonly :value="rating[2]" :length="length"
                                                            :size=this.starsize :color=this.starcolor
                                                            :background-color=this.starstrokecolor dense></v-rating>
                                                    </td>
                                                    <td class="td_markup">{{this.reviews.VFY.Score3}}</td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <v-rating readonly :value="rating[1]" :length="length"
                                                            :size=this.starsize :color=this.starcolor
                                                            :background-color=this.starstrokecolor dense></v-rating>
                                                    </td>
                                                    <td class="td_markup">{{this.reviews.VFY.Score2}}</td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <v-rating readonly :value="rating[0]" :length="length"
                                                            :size=this.starsize :color=this.starcolor
                                                            :background-color=this.starstrokecolor dense></v-rating>
                                                    </td>
                                                    <td class="td_markup">{{this.reviews.VFY.Score1}}</td>
                                                </tr>
                                                <tr>
                                                    <td class="td_markup">Total </td>
                                                    <td class="td_markup td_column">{{getTotalVFYScore()}}</td>
                                                </tr>
                                            </table>
                                        </div>
                                    </v-row>
                                </v-card-text>
                            </v-container>
                        </v-card>
                    </v-col>
                    <v-col xs="12" sm="6" md="4" lg="3" xl="3">
                        <v-card class="score-semitrans-25" elevation="8">
                            <v-container>
                                <h5>Partners</h5>
                                <v-card-text>
                                    <v-row cols="12">
                                        <div v-if="this.hasData(this.reviews)">
                                            <table dense class="table_markup">
                                                <tr class="td_column_stat2">
                                                    <td>
                                                        <v-rating readonly :value="rating[4]" :length="length"
                                                            :size=this.starsize :color=this.starcolor
                                                            :background-color=this.starstrokecolor dense></v-rating>
                                                    </td>
                                                    <td class="td_markup td_column_stat100">
                                                        {{this.reviews.Partner.Score5}}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <v-rating readonly :value="rating[3]" :length="length"
                                                            :size=this.starsize :color=this.starcolor
                                                            :background-color=this.starstrokecolor dense></v-rating>
                                                    </td>
                                                    <td class="td_markup">{{this.reviews.Partner.Score4}}</td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <v-rating readonly :value="rating[2]" :length="length"
                                                            :size=this.starsize :color=this.starcolor
                                                            :background-color=this.starstrokecolor dense></v-rating>
                                                    </td>
                                                    <td class="td_markup">{{this.reviews.Partner.Score3}}</td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <v-rating readonly :value="rating[1]" :length="length"
                                                            :size=this.starsize :color=this.starcolor
                                                            :background-color=this.starstrokecolor dense></v-rating>
                                                    </td>
                                                    <td class="td_markup">{{this.reviews.Partner.Score2}}</td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <v-rating readonly :value="rating[0]" :length="length"
                                                            :size=this.starsize :color=this.starcolor
                                                            :background-color=this.starstrokecolor dense></v-rating>
                                                    </td>
                                                    <td class="td_markup">{{this.reviews.Partner.Score1}}</td>
                                                </tr>
                                                <tr>
                                                    <td class="td_markup">Total </td>
                                                    <td class="td_markup td_column">{{getTotalPartnerScore()}}</td>
                                                </tr>
                                            </table>
                                        </div>
                                    </v-row>
                                </v-card-text>
                            </v-container>
                        </v-card>
                    </v-col>
                    <v-col xs="12" sm="6" md="4" lg="3" xl="3">
                        <v-card class="score-semitrans-25" elevation="8">
                            <v-container>
                                <h5>Total</h5>
                                <v-card-text>
                                    <v-row cols="12">
                                        <div v-if="this.hasData(this.reviews)">
                                            <table dense class="table_markup">
                                                <tr class="td_column_stat2">
                                                    <td>
                                                        <v-rating readonly :value="rating[4]" :length="length"
                                                            :size=this.starsize :color=this.starcolor
                                                            :background-color=this.starstrokecolor dense></v-rating>
                                                    </td>
                                                    <td class="td_markup td_column_stat100">
                                                        {{this.reviews.Total.Score5}}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <v-rating readonly :value="rating[3]" :length="length"
                                                            :size=this.starsize :color=this.starcolor
                                                            :background-color=this.starstrokecolor dense></v-rating>
                                                    </td>
                                                    <td class="td_markup">{{this.reviews.Total.Score4}}</td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <v-rating readonly :value="rating[2]" :length="length"
                                                            :size=this.starsize :color=this.starcolor
                                                            :background-color=this.starstrokecolor dense></v-rating>
                                                    </td>
                                                    <td class="td_markup">{{this.reviews.Total.Score3}}</td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <v-rating readonly :value="rating[1]" :length="length"
                                                            :size=this.starsize :color=this.starcolor
                                                            :background-color=this.starstrokecolor dense></v-rating>
                                                    </td>
                                                    <td class="td_markup">{{this.reviews.Total.Score2}}</td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <v-rating readonly :value="rating[0]" :length="length"
                                                            :size=this.starsize :color=this.starcolor
                                                            :background-color=this.starstrokecolor dense></v-rating>
                                                    </td>
                                                    <td class="td_markup">{{this.reviews.Total.Score1}}</td>
                                                </tr>
                                                <tr>
                                                    <td class="td_markup">Total </td>
                                                    <td class="td_markup td_column">{{getTotalTotalScore()}}</td>
                                                </tr>
                                            </table>
                                        </div>
                                    </v-row>
                                </v-card-text>
                            </v-container>
                        </v-card>
                    </v-col>
                    <v-col xs="12" sm="6" md="4" lg="3" xl="3">
                        <v-card class="score-semitrans-25" elevation="8">
                            <v-container>
                                <h5>Current Situation</h5>
                                <v-card-text>
                                    <v-row cols="12">
                                        <div v-if="this.hasData(this.reviews)">
                                            <table dense class="table_markup">
                                                <tr class="td_column_stat2">
                                                    <td class="td_markup_xl">
                                                        Published
                                                    </td>
                                                    <td class="td_markup td_column_stat90">
                                                        {{this.reviews.Total.Published}}</td>
                                                </tr>
                                                <tr>
                                                    <td class="td_markup_xl">
                                                        Closed
                                                    </td>
                                                    <td class="td_markup">{{this.reviews.Total.Closed}}</td>
                                                </tr>
                                                <tr>
                                                    <td class="td_markup_xl">
                                                        Assigned
                                                    </td>
                                                    <td class="td_markup">{{this.reviews.Total.Unpublished}}</td>
                                                </tr>                                                
                                                <tr>
                                                    <td class="td_markup_xl">
                                                        Unassigned
                                                    </td>
                                                    <td class="td_markup">{{this.reviews.Total.NotAssigned}}</td>
                                                </tr>
                                                <tr>
                                                    <td class="td_markup_xl">
                                                        &nbsp;
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td class="td_markup_asty_xs">
                                                        Assigned to you
                                                    </td>
                                                    <td class="td_markup_asty">{{this.reviews.Total.AssignedToYou}}
                                                    </td>
                                                </tr>

                                            </table>
                                        </div>
                                    </v-row>
                                </v-card-text>
                            </v-container>
                        </v-card>
                    </v-col>
                </v-row>
                <span class="br_large"></span>
                <v-divider color="white"></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn v-bind="attrs" v-on="on" icon v-on:click="openSubScreen()">
                                <v-icon color="white">mdi-open-in-app</v-icon>
                            </v-btn>
                        </template>
                        <span style="text-align: right;">Show me the reviews...</span>
                    </v-tooltip>
                </v-card-actions>
            </v-container>
        </v-card>
    </div>
</template>
<script>

import { bus } from "../../../../main";
import mxhasdata from '@/mixins/hasdata2';

export default {
    props: {
        gebr: {
            type: Object,
            default: () => ({}),
        }
    },
    components: {},
    data() {
        return {
            reviews: {},
            claims: [],
            starsize: "17",
            starcolor: "#FFFF00", 
            starstrokecolor: "#D3D3D3",
            length: 5,
            rating: [1, 2, 3, 4, 5]
        }
    },
    mounted(){},
    created() {
        // here we will add the axios call to get the bookings from ares and assign the bookings var
        this.getReviewOverview();
        bus.$on("refresh", (data) => {
            console.log("refresh received for reviews " + data);
            this.getReviewOverview();
        });
    },
    mixins:[mxhasdata],  
    methods: {
        openSubScreen() {

            // console.log("gebr", this.gebr.gebr_encrid);
            let route = this.$router.resolve({ path: '/task/customer_success/revw/revw_overview3/user:' + this.gebr.gebr_xencrid + ':ac1U1L111J6U4O4Z2R3O130L026C07531B0K690Q4Q1U4Y6A0P5O2C6T6D044S0L6U6Q052W2Q6F630U381J5C4N603B:0:true'}); 
            window.open(route.href, '_blank');

        },
        getTotalVFYScore() {
            return (this.reviews.VFY.Score1 + this.reviews.VFY.Score2 + this.reviews.VFY.Score3 + this.reviews.VFY.Score4 + this.reviews.VFY.Score5);
        },
        getTotalPartnerScore() {
            return (this.reviews.Partner.Score1 + this.reviews.Partner.Score2 + this.reviews.Partner.Score3 + this.reviews.Partner.Score4 + this.reviews.Partner.Score5);
        },
        getTotalTotalScore() {
            return (this.reviews.Total.Score1 + this.reviews.Total.Score2 + this.reviews.Total.Score3 + this.reviews.Total.Score4 + this.reviews.Total.Score5);
        },
        getReviewOverview() {
            this.$axios
                .post("ares/json/ares/syst/dashboard/getReviewsOverview.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getReviewsOverview"
                    },
                })
                .then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {                        
                        this.reviews = res.data.getReviewsOverview;
                        console.log(JSON.stringify(this.reviews));
                    }
                })
                .finally(() => {
                });
        },
    }
}
</script>
<style scoped>
    .review_card {
        background: url('../assets/search_nightmare_2.png') !important;
        background-size: cover !important;
    }

    .caption-font {
        font-size: 30px;
        font-weight: bold;
    }

    .br_large {
        display: block;
        margin-bottom: 2em;
    }

    .td_markup {
        text-align: right;
        font-size: 14px !important;
        line-height: 22px !important;
    }

    .td_markup_xl {
        font-size: 14px !important;
        line-height: 22px !important;
    }

    .td_markup_asty {
        text-align: right;
        font-size: 25px !important;
        font-weight: bolder;
        line-height: 22px !important;
        color: white;
    }

    .td_markup_asty_xs {
        font-size: 16px !important;
        font-weight: bolder;
        line-height: 22px !important;
        color: white;
    }

    .table_markup {
        font-size: 14px !important;
        width: 100% !important;
    }

    .td_column {
        width: 40px !important;
        font-weight: bold !important;
    }

    .td_column_stat100 {
        width: 100px !important;
    }
    .td_column_stat90 {
        width: 90px !important;
    }

    .td_column_stat2 {
        width: 30px !important;
    }

    .score-semitrans-25 {
        background-color: rgba(200, 247, 197, 0.50);
    }    
</style>